import { fabric } from 'fabric';
import * as setting from './fabric.eg.setting';
import $ from 'jquery';
import { intersectionPointOfCircleAndLine, util } from '../util';
import _ from 'lodash';

fabric.eg = {};
fabric.eg._uuidHash = [];
fabric.eg._drawing = null;
fabric.eg._userid = 0;
fabric.eg._username = 'anonymous';
fabric.eg._company_name = 'anonymous';
fabric.eg._runningInBrowser = typeof window !== 'undefined';
fabric.eg._minimumRadius = 0.1; //egEllipse(楕円)の最小半径
fabric.eg._loadImageSrc = setting.loadImageSrc;
fabric.eg._exportImageSrc = setting.exportImageSrc;

// 初期化
fabric.eg.init = function({ drawing, userId, userName, companyName }) {
  fabric.eg._drawing = drawing;

  // 利用者情報
  fabric.eg._userid = userId;
  fabric.eg._username = userName;
  fabric.eg._company_name = companyName;
};

// uuidからオブジェクトを取得
fabric.eg.getFromUuid = function(uuid) {
  if (fabric.eg._uuidHash[uuid]) {
    return fabric.eg._uuidHash[uuid];
  } else {
    return undefined;
  }
};

// オブジェクトにuuidを設定
fabric.eg.setUuid = function(object, uuid) {
  fabric.eg._uuidHash[uuid] = object;
};

// uuidを削除
fabric.eg.removeUuid = function(uuid) {
  if (fabric.eg._uuidHash[uuid]) {
    fabric.eg._uuidHash[uuid] = null;
    delete fabric.eg._uuidHash[uuid];
  }
};

// 拡張クラス初期化時の共通処理
fabric.eg._initialize = function(c, o) {
  var ts = util.getTimeStamp();
  var uuid = o.uuid || '';
  var fg = false;
  if (uuid == '') {
    uuid = util.getUuid();
    fg = true;
  }
  c.set('uuid', uuid);
  if (fg) {
    c.set('createrId', fabric.eg._userid);
    c.set('createrName', fabric.eg._username);
    c.set('createrCompanyName', fabric.eg._company_name);
    c.set('created', ts);
    c.set('updaterId', fabric.eg._userid);
    c.set('updaterName', fabric.eg._username);
    c.set('updaterCompanyName', fabric.eg._company_name);
    c.set('updated', ts);
    c.set('lockManager', -1);
    c.set('lockForeman', -1);
    c.set('lockerName', '');
    c.set('lockerCompanyName', '');
    c.set('locked', 0);
  } else {
    c.set('createrId', o.createrId || fabric.eg._userid);
    c.set('createrName', o.createrName || fabric.eg._username);
    c.set(
      'createrCompanyName',
      o.createrCompanyName || fabric.eg._company_name
    );
    c.set('created', o.created || ts);
    c.set('updaterId', o.updaterId || fabric.eg._userid);
    c.set('updaterName', o.updaterName || fabric.eg._username);
    c.set(
      'updaterCompanyName',
      o.updaterCompanyName || fabric.eg._company_name
    );
    c.set('updated', o.updated || ts);
    c.set('lockManager', o.lockManager);
    c.set('lockForeman', o.lockForeman);
    c.set('lockerName', o.lockerName || '');
    c.set('lockerCompanyName', o.lockerCompanyName || '');
    c.set('locked', o.locked || 0);
  }
  if (c.strokeWidth) {
    c.set('egStrokeWidth', c.strokeWidth);
  }
  fabric.eg._uuidHash[uuid] = c;
};

// 拡張クラス更新の共通処理
fabric.eg._update = function(c) {
  c.set('updaterId', fabric.eg._userid);
  c.set('updaterName', fabric.eg._username);
  c.set('updaterCompanyName', fabric.eg._company_name);
  c.set('updated', util.getTimeStamp());
};

// 拡張クラス削除時の共通処理
fabric.eg._destructer = function(c) {
  delete fabric.eg._uuidHash[c.get('uuid')];
};

// 拡張クラスの追加プロパティを取得
fabric.eg._object = function(c) {
  var ret = {
    uuid: c.get('uuid'),
    createrId: c.get('createrId'),
    createrName: c.get('createrName'),
    createrCompanyName: c.get('createrCompanyName'),
    created: c.get('created'),
    updaterId: c.get('updaterId'),
    updaterName: c.get('updaterName'),
    updaterCompanyName: c.get('updaterCompanyName'),
    updated: c.get('updated'),
    lockManager: c.get('lockManager'),
    lockForeman: c.get('lockForeman'),
    lockerName: c.get('lockerName'),
    lockerCompanyName: c.get('lockerCompanyName'),
    locked: c.get('locked'),
  };

  if (c.type == 'egLine' || c.type == 'egPolyline') {
    ret['arrowStart'] = c.get('arrowStart');
    ret['arrowEnd'] = c.get('arrowEnd');
    ret['arrowSize'] = c.get('arrowSize');
  }

  return ret;
};

// 拡張クラスの共通クラスを作成する 必要な場合は個別に上書きする
fabric.eg.createEgClass = (parent, implementObj) =>
  fabric.util.createClass(parent, {
    initialize(options) {
      options = options || (options = {});
      this.callSuper('initialize', options);
      fabric.eg._initialize(this, options);
    },
    toObject(propertiesToInclude) {
      return fabric.util.object.extend(
        this.callSuper('toObject'),
        fabric.eg._object(this, propertiesToInclude)
      );
    },
    _clearUuIdForCloneSource(obj) {
      if (obj.uuid) {
        obj.uuid = '';
      }

      // Groupの場合
      if (obj.objects) {
        for (let i = 0; i < obj.objects.length; i++) {
          this._clearUuIdForCloneSource(obj.objects[i]);
        }
      }
    },
    clone(callback, propertiesToInclude) {
      // fabric.Objectのcloneと同様のコード
      // WARNING:fabric.js 1.6.7からverupする際はコード再確認 return廃止になっている
      const object = this.toObject(propertiesToInclude);
      // uuidを削除しておくことでfromObjectでnewする際にinitializeで再設定する
      this._clearUuIdForCloneSource(object);
      // toObjectしてからfromObjectして新しいインスタンスを作成することでイベントの再設定などを正しく行える
      // Groupの場合もこれで問題ない
      if (this.constructor.fromObject) {
        return this.constructor.fromObject(object, callback);
      } else {
        return new fabric.Object(object);
      }
    },
    _render(ctx) {
      this.callSuper('_render', ctx);
    },
    update() {
      fabric.eg._update(this);
    },
    destructer() {
      fabric.eg._destructer(this);
    },
    ...implementObj,
  });

fabric.EgGroup = fabric.eg.createEgClass(fabric.Group, {
  type: 'egGroup',
  strokeUniform: true,
  initialize(objects, options) {
    options || (options = {});
    this.callSuper('initialize', objects, options);
    fabric.eg._initialize(this, options);
  },
  toObject() {
    var renderObj = fabric.util.object.extend(
      this.callSuper('toObject'),
      fabric.eg._object(this)
    );

    //DEM-373
    delete renderObj['fill'];
    delete renderObj['stroke'];
    delete renderObj['strokeWidth'];
    delete renderObj['strokeDashArray'];

    return renderObj;
  },
});

// WARNING: fromObjectはcallBackに加えてreturnも実装している cloneではcallbackのみを使用
// fabric.js 1.6.7ではreturn必要そうだがverupでreturnは廃止されるのでverupする際に注意

if (fabric.eg._runningInBrowser) {
  fabric.EgGroup.fromObject = function(object, callback) {
    fabric.util.enlivenObjects(object.objects, function(enlivenedObjects) {
      delete object.objects;
      delete object.fill;
      if (callback) {
        callback(new fabric.EgGroup(enlivenedObjects, object));
      }
    });
  };

  fabric.EgGroup.async = true;
} else {
  fabric.EgGroup.fromObject = function(object, callback) {
    var _enlivenedObjects;
    fabric.util.enlivenObjects(object.objects, function(enlivenedObjects) {
      delete object.objects;
      _enlivenedObjects = enlivenedObjects;
    });
    delete object.fill;
    const result = new fabric.EgGroup(_enlivenedObjects, object);
    callback && callback(result);
    return result;
  };

  fabric.EgGroup.async = false;
}

fabric.EgPath = fabric.eg.createEgClass(fabric.Path, {
  type: 'egPath',
  strokeUniform: true,
  // BLDE_V2-27371 線のオブジェクトがバウンディングボックスではなく、ピクセルごとにキャンバス上で「検出」されるため
  perPixelTargetFind: true,
  initialize(path, options) {
    options = options || (options = {});
    this.callSuper('initialize', path, options);
    fabric.eg._initialize(this, options);
  },
});

fabric.EgPath.fromObject = function(object, callBack) {
  const result = new fabric.EgPath(object.path, object);
  callBack && callBack(result);
  return result;
};

fabric.EgSector = fabric.eg.createEgClass(fabric.Path, {
  type: 'egSector',
  strokeUniform: true,
  initialize(path, options) {
    options = options || (options = {});
    this.callSuper('initialize', path, options);
    fabric.eg._initialize(this, options);
  },
});

fabric.EgSector.fromObject = function(object, callBack) {
  const result = new fabric.EgSector(object.path, object);
  callBack && callBack(result);
  return result;
};

fabric.EgRect = fabric.eg.createEgClass(fabric.Rect, {
  type: 'egRect',
});

fabric.EgRect.fromObject = function(object, callBack) {
  // When zoom up or change border size, the object is missing strokes
  object.strokeDashArray = _.isEqual(object.strokeDashArray, [1, 0])
    ? []
    : object.strokeDashArray;
  const result = new fabric.EgRect(object);
  callBack && callBack(result);
  return result;
};

fabric.EgEllipse = fabric.eg.createEgClass(fabric.Ellipse, {
  type: 'egEllipse',
  strokeUniform: true,
  _set(key, value) {
    if (key === 'rx' || key === 'ry') {
      // 半径が0になるとサーバ側の印刷処理が中断されるので最小値を設定
      if (value < fabric.eg._minimumRadius) {
        // rx,ryの場合は_setメソッド内部でwidth,heightも設定される
        return this.callSuper('_set', key, fabric.eg._minimumRadius);
      }
    }

    return this.callSuper('_set', key, value);
  },
});

fabric.EgEllipse.fromObject = function(object, callBack) {
  // 半径が0にならないようにしているが、バグ修正前の既存で存在する場合の対策
  // クライアント: 0の場合には画面上見えないが_setで補正されて見えるようになるので既存データにある場合は見えないようにする
  // サーバ: 印刷処理では0があると中断されるので非表示にすることで回避
  if (object.rx === 0 || object.ry === 0) {
    const result = new fabric.EgEllipse({ ...object, visible: false });
    callBack && callBack(result);
    return result;
  }
  const result = new fabric.EgEllipse(object);
  callBack && callBack(result);
  return result;
};

fabric.EgLine = fabric.eg.createEgClass(fabric.Line, {
  type: 'egLine',
  strokeUniform: true,
  objectCaching: false,
  // BLDE_V2-27371 線のオブジェクトがバウンディングボックスではなく、ピクセルごとにキャンバス上で「検出」されるため
  perPixelTargetFind: true,
  initialize(pos, options) {
    options = options || (options = {});
    this.callSuper('initialize', pos, options);
    fabric.eg._initialize(this, options);
    var arrowStart = options.arrowStart || false;
    var arrowEnd = options.arrowEnd || false;
    var arrowSize = options.arrowSize || 10;
    this.set('arrowStart', arrowStart);
    this.set('arrowEnd', arrowEnd);
    this.set('arrowSize', arrowSize);
  },
  _render(ctx) {
    this.callSuper('_render', ctx);

    if (this.arrowStart || this.arrowEnd) {
      // 非可視、もしくは高さか幅が０の場合には描画しない
      if (!this.visible) {
        return;
      }

      ctx.save();

      var sz1 = this.arrowSize;
      var sz2 = sz1 * 0.8;
      // Recalculates line points
      const points = this.calcLinePoints();
      var xDiff = points.x2 - points.x1;
      var yDiff = points.y2 - points.y1;
      var angle = Math.atan2(yDiff, xDiff);

      var sx;
      var sy;
      if (xDiff != 0) {
        sx = this.width / Math.abs(xDiff);
      } else {
        sx = 0;
      }
      if (yDiff != 0) {
        sy = this.height / Math.abs(yDiff);
      } else {
        sy = 0;
      }

      var len = Math.sqrt(Math.pow(yDiff * sy, 2) + Math.pow(xDiff * sx, 2));
      ctx.translate(
        ((points.x2 - points.x1) / 2) * sx,
        ((points.y2 - points.y1) / 2) * sy
      );

      ctx.rotate(angle);
      if (this.arrowEnd) {
        ctx.beginPath();
        ctx.moveTo(sz1, 0);
        ctx.lineTo(0, sz2);
        ctx.lineTo(0, sz2 * -1);
        ctx.closePath();
        ctx.fillStyle = this.stroke;
        ctx.fill();
      }
      if (this.arrowStart) {
        ctx.beginPath();
        ctx.moveTo(0 - len - sz1, 0);
        ctx.lineTo(0 - len, sz2);
        ctx.lineTo(0 - len, sz2 * -1);
        ctx.closePath();
        ctx.fillStyle = this.stroke;
        ctx.fill();
      }
      ctx.restore();
    }
  },
});

fabric.EgLine.fromObject = function(object, callBack) {
  const result = new fabric.EgLine(
    [object.x1, object.y1, object.x2, object.y2],
    object
  );
  callBack && callBack(result);
  return result;
};

fabric.EgPolygon = fabric.eg.createEgClass(fabric.Polygon, {
  type: 'egPolygon',
  initialize(points, options) {
    options = options || (options = {});
    this.callSuper('initialize', points, options);
    fabric.eg._initialize(this, options);
  },
});

fabric.EgPolygon.fromObject = function(object, callBack) {
  // When zoom up or change border size, the object is missing strokes
  object.strokeDashArray = _.isEqual(object.strokeDashArray, [1, 0])
    ? []
    : object.strokeDashArray;
  const result = new fabric.EgPolygon(object.points, object);
  callBack && callBack(result);
  return result;
};
fabric.Object.prototype.objectCaching = false;
fabric.Object.prototype.dirty = true;

fabric.EgPolyline = fabric.eg.createEgClass(fabric.Polyline, {
  type: 'egPolyline',
  strokeUniform: true,
  // BLDE_V2-27371 線のオブジェクトがバウンディングボックスではなく、ピクセルごとにキャンバス上で「検出」されるため
  perPixelTargetFind: true,
  initialize(points, options) {
    options = options || (options = {});
    this.callSuper('initialize', points, options);
    fabric.eg._initialize(this, options);
    var arrowStart = options.arrowStart || false;
    var arrowEnd = options.arrowEnd || false;
    var arrowSize = options.arrowSize || 10;
    this.set('arrowStart', arrowStart);
    this.set('arrowEnd', arrowEnd);
    this.set('arrowSize', arrowSize);
  },
  _arrowRender(ctx, startPoint, endPoint) {
    ctx.save();

    const sz1 = this.arrowSize;
    const sz2 = sz1 * 0.8;

    let xDiff = startPoint.x - endPoint.x;
    let yDiff = startPoint.y - endPoint.y;
    let angle = Math.atan2(yDiff, xDiff);
    // When stop drawing, the arrows are in wrong place
    ctx.translate(
      endPoint.x - this.pathOffset.x,
      endPoint.y - this.pathOffset.y
    );
    ctx.rotate(angle);
    ctx.beginPath();
    ctx.moveTo(sz1 * -1, 0);
    ctx.lineTo(0, sz2);
    ctx.lineTo(0, sz2 * -1);
    ctx.closePath();
    ctx.fillStyle = this.stroke;
    ctx.fill();

    ctx.restore();
  },
  _render(ctx) {
    this.callSuper('_render', ctx);
    if (this.arrowStart || this.arrowEnd) {
      // 非可視、もしくは高さか幅が０の場合には描画しない
      if (
        this.width === 0 ||
        this.height === 0 ||
        !this.visible ||
        this.points.length < 2
      ) {
        return;
      }
      if (this.arrowStart) {
        // 2番目の頂点から1番目の頂点の方向に矢印を作成
        this._arrowRender(ctx, this.points[1], this.points[0]);
      }
      if (this.arrowEnd) {
        const length = this.points.length;
        // 最後の1つ前の頂点から最後の頂点の方向に矢印を作成
        this._arrowRender(
          ctx,
          this.points[length - 2],
          this.points[length - 1]
        );
      }
    }
  },
});

fabric.EgPolyline.fromObject = function(object, callBack) {
  const result = new fabric.EgPolyline(object.points, object);
  callBack && callBack(result);
  return result;
};
let focusItextInterval = undefined;
fabric.EgText = fabric.eg.createEgClass(fabric.IText, {
  type: 'egText',
  initialize(pos, options) {
    options = options || (options = {});
    // BLDE_V2-22855 何らかのバグでtextプロパティが存在しない場合があり、loadFromJSONでエラーになるので補完する
    // 他に値がnullやundefinedの場合もエラーになるためisNilで確認
    if (_.isNil(options.text)) {
      console.warn('egText.text is nil');
      options.text = '';
    }
    this.callSuper('initialize', pos, options);
    fabric.eg._initialize(this, options);
    // Selection box on tablet smaller than on pc
    this.fontSize = Math.round(this.fontSize);
    this.addEvent();
  },
  _showTextArea() {
    if (this.locked) {
      this.exitEditing();
      return;
    }
    this.hasBorders = false;
    this.hasControls = false;
    const itextForm = $('<textarea/>').addClass('itext');
    const viewport = fabric.eg._drawing._canvas.viewportTransform;
    const porntX = this.left * fabric.eg._drawing._zoom + viewport[4];
    const porntY = this.top * fabric.eg._drawing._zoom + viewport[5];
    itextForm
      .css({
        left: porntX,
        top: porntY,
        'line-height': this.lineHeight,
        'font-family': this.fontFamily,
        'font-size': `${Math.floor(
          this.fontSize * Math.min(this.scaleX, this.scaleY)
        )}px`,
        'font-weight': this.fontWeight,
        'font-style': this.fontStyle,
        position: 'absolute',
      })
      .val(this.text)
      .appendTo(
        $(fabric.eg._drawing._canvas.wrapperEl).closest('.canvas-container')
      );
    fabric.eg._drawing.currentItextUuid = this.uuid;
    // Focus on text
    setTimeout(function() {
      itextForm.select();
    }, 1);
    itextForm.on('mouseover', () => {
      if (itextForm) {
        itextForm.focus();
      }
    });
    // Avoid text area lost focus
    focusItextInterval = setInterval(() => {
      if (itextForm) {
        itextForm.focus();
      }
    }, 200);
    // New version fabric change how itext focusout and focusin
    // Implement custom event to detect if user click outside itext object
    const outSideElements = $(
      '.btn-rail-master-navi, .btn-rail-navi, .layout-tool, .layout-header, .layout-canvas__header, .global-header__bar, .sys_select_color'
    );
    outSideElements.off('click.outside');
    outSideElements.on('click.outside', function() {
      if (fabric.eg._drawing.currentItextUuid) {
        const element = fabric.eg.getFromUuid(
          fabric.eg._drawing.currentItextUuid
        );
        element.submitText();
      }
    });
  },
  submitText() {
    clearInterval(focusItextInterval);
    const itextForm = $('.itext');
    this.exitEditing();
    this.set('text', itextForm.val());
    itextForm.remove();
    this.hasBorders = true;
    this.hasControls = true;
    fabric.eg._drawing._canvas.requestRenderAll();
    fabric.eg._drawing.client.push({
      action: 'attribute',
      uuid: this.uuid,
      text: this.text,
    });
    fabric.eg._drawing.client.flush();
    const history = fabric.eg._drawing.historyInit();
    fabric.eg._drawing.historyPush(this, history);
    fabric.eg._drawing.historySet('modify', history);
    fabric.eg._drawing.currentItextUuid = undefined;
    if (!fabric.eg._drawing._canvas.egTextReachMaxCount) {
      fabric.eg._drawing._canvas.setActiveObject(this);
    } else {
      fabric.eg._drawing._canvas.egTextReachMaxCount = false;
    }
  },
  addEvent() {
    this.on('editing:entered', this._showTextArea);
  },
});

fabric.EgText.fromObject = function(object, callBack) {
  const result = new fabric.EgText(object.text, object);
  callBack && callBack(result);
  return result;
};

fabric.EgImage = fabric.eg.createEgClass(fabric.Image, {
  type: 'egImage',
  initialize(img, options) {
    options = options || (options = {});
    this.callSuper('initialize', img, options);
    fabric.eg._initialize(this, options);
  },
});

fabric.EgImage.async = true;
/*
 * Fix: The old JSON will not load properly if the image dimensions have been modified.
 * Ref: http://fabricjs.com/v2-breaking-changes
 */
const imageFromObject = function(object, callback, createInstance) {
  fabric.util.loadImage(
    fabric.eg._loadImageSrc(object.src),
    function(img, error) {
      if (error) {
        callback && callback(null, error);
        return;
      }
      fabric.Image.prototype._initFilters.call(object, object.filters, function(
        filters
      ) {
        object.filters = filters || [];
        fabric.Image.prototype._initFilters.call(
          object,
          [object.resizeFilter],
          function(resizeFilters) {
            object.resizeFilter = resizeFilters[0];
            if (typeof object.version === 'undefined') {
              const elWidth = img.naturalWidth || img.width;
              const elHeight = img.naturalHeight || img.height;
              const scaleX = ((object.scaleX || 1) * object.width) / elWidth;
              const scaleY = ((object.scaleY || 1) * object.height) / elHeight;
              object.width = elWidth;
              object.height = elHeight;
              object.scaleX = scaleX;
              object.scaleY = scaleY;
            }
            callback && callback(createInstance(img, object));
          }
        );
      });
    },
    null,
    object.crossOrigin
  );
};

const imageFromUrl = function(url, callback, imageOptions, createInstance) {
  fabric.util.loadImage(fabric.eg._loadImageSrc(url), function(img) {
    callback && callback(createInstance(img, imageOptions));
  });
};

fabric.EgImage.fromObject = function(object, callback) {
  imageFromObject(
    object,
    callback,
    (img, object) => new fabric.EgImage(img, object)
  );
};

fabric.EgImage.fromURL = function(url, callback, imageOptions) {
  imageFromUrl(
    url,
    callback,
    imageOptions,
    (img, imageOptions) => new fabric.EgImage(img, imageOptions)
  );
};

// 背景やパーツでImageが使用されているのでEgImageと同様の実装が必要
fabric.Image.fromObject = function(object, callback) {
  imageFromObject(
    object,
    callback,
    (img, object) => new fabric.Image(img, object)
  );
};

fabric.Image.fromURL = function(url, callback, imageOptions) {
  imageFromUrl(
    url,
    callback,
    imageOptions,
    (img, imageOptions) => new fabric.Image(img, imageOptions)
  );
};

fabric.Image.prototype.toObject = (function(toObject) {
  return function() {
    return fabric.util.object.extend(toObject.call(this), {
      src: fabric.eg._exportImageSrc(this.getSrc()),
    });
  };
})(fabric.Image.prototype.toObject);

fabric.CustomFreehand = fabric.eg.createEgClass(fabric.Group, {
  type: 'customFreehand',
  strokeUniform: true,
  objectCaching: false,
  initialize(objects, options) {
    options = options || {};
    this.callSuper('initialize', objects, options);
    fabric.eg._initialize(this, options);

    this.strokeSize = options.strokeSize || 1;
    this.strokeColor = options.strokeColor || '#000000';
  },
  toObject(propertiesToInclude) {
    const dataPointsList = this._objects.map(obj => obj.dataPoints || null);
    const source = fabric.eg._object(this);
    return fabric.util.object.extend(
      this.callSuper('toObject', propertiesToInclude),
      {
        ...source,
        dataPointsList,
        strokeSize: this.strokeSize,
        strokeColor: this.strokeColor,
      },
    );
  },
});

fabric.CustomFreehand.fromObject = function (object, callback) {
  fabric.util.enlivenObjects(object.objects, function (enlivenedObjects) {
    delete object.objects;
    const group = new fabric.CustomFreehand(enlivenedObjects, object);

    if (object.dataPointsList && Array.isArray(object.dataPointsList)) {
      object.dataPointsList.forEach((points, i) => {
        if (group._objects[i]) {
          group._objects[i].dataPoints = points;
        }
      });
    }

    if (object.strokeSize) {
      group.strokeSize = object.strokeSize;
    }
    if (object.strokeColor) {
      group.strokeColor = object.strokeColor;
    }

    callback && callback(group);
    return group;
  });
};

fabric.CustomFreehand.async = true;

// customise fabric.Object with a method to resize rather than just scale after tranformation
fabric.Object.prototype.resizeToScale = function(
  sx,
  sy,
  isGroup,
  selectMultiContainsImage,
  isUndo
) {
  let isSingleSelect = false;
  // resizes an object that has been scaled (e.g. by manipulating the handles), setting scale to 1 and recalculating bounding box where necessary
  this.objectCaching = false;
  this.dirty = true;
  if (sx === undefined) {
    sx = this.scaleX;
    isSingleSelect = true;
  }
  if (sy === undefined) {
    sy = this.scaleY;
    isSingleSelect = true;
  }
  switch (this.type) {
    case 'egEllipse':
      this.rx *= sx;
      this.ry *= sy;
      this.width = this.rx * 2;
      this.height = this.ry * 2;
      this.scaleX = 1;
      this.scaleY = 1;
      break;
    case 'egPolyline':
    case 'egPolygon':
      {
        const w = this.width;
        const h = this.height;
        const b = this.getBoundingBox();
        const x = b.topLeft.x;
        const y = b.topLeft.y;
        this.points = _.map(this.get('points'), p => {
          return {
            ...p,
            x: (p.x - x) * sx + x,
            y: (p.y - y) * sy + y,
          };
        });
        this.width = this.getBoundingBox().width;
        this.height = this.getBoundingBox().height;
        this.scaleX = 1;
        this.scaleY = 1;
        this.pathOffset = {
          ...this.pathOffset,
          x: this.pathOffset.x - w / 2 + this.width / 2,
          y: this.pathOffset.y - h / 2 + this.height / 2,
        };
      }
      break;
    case 'egPath':
      {
        var path = this.get('path').concat();
        let w = this.width;
        let h = this.height;
        let b = this.getBoundingBox();
        let x = b.topLeft.x;
        let y = b.topLeft.y;
        for (let i = 0; i < path.length; i++) {
          let p = path[i].concat();
          for (var m = 1; m < p.length; m = m + 2) {
            p[m + 0] = (p[m + 0] - x) * sx + x;
            p[m + 1] = (p[m + 1] - y) * sy + y;
          }
          path[i] = p;
        }
        this.path = path;
        this.width = this.getBoundingBox().width;
        this.height = this.getBoundingBox().height;
        this.scaleX = 1;
        this.scaleY = 1;
        let pathOffset = $.extend({}, this.pathOffset);
        pathOffset.x = pathOffset.x - w / 2 + this.width / 2;
        pathOffset.y = pathOffset.y - h / 2 + this.height / 2;
        this.pathOffset = pathOffset;
      }
      break;
    case 'egText':
      if (isGroup) {
        this.scaleX *= sx;
        this.scaleY *= sy;
      }
      break;
    case 'egImage':
      if (selectMultiContainsImage) {
        this.scaleX *= sx;
        this.scaleY *= sy;
      }
      break;
    case 'egLine':
      this.width *= sx;
      this.height *= sy;
      this.x1 *= sx;
      this.x2 *= sx;
      this.y1 *= sy;
      this.y2 *= sy;
      this.scaleX = 1;
      this.scaleY = 1;
      break;
    case 'egRect':
      this.width *= sx;
      this.height *= sy;
      this.scaleX = 1;
      this.scaleY = 1;
      break;
    case 'egGroup':
      for (let i = 0; i < this._objects.length; i++) {
        this._objects[i].left *= sx;
        this._objects[i].top *= sy;
        this._objects[i].resizeToScale(sx, sy, true, true, isUndo);
      }
      this.width *= sx;
      this.height *= sy;
      this.scaleX = 1;
      this.scaleY = 1;
      break;
    case 'egSector':
      const scale = isUndo ? Math.max(sx, sy) : Math.min(sx, sy);
      let newRadius = (this.width / 2) * scale;
      const currentPoint1 = this.path[3];
      const currentPoint2 = this.path[4];
      const centerPoint = [0, 0];
      const newPoint1 = intersectionPointOfCircleAndLine(
        centerPoint[0],
        centerPoint[1],
        newRadius,
        currentPoint1[1],
        currentPoint1[2]
      );
      const newPoint2 = intersectionPointOfCircleAndLine(
        centerPoint[0],
        centerPoint[1],
        newRadius,
        currentPoint2[6],
        currentPoint2[7]
      );
      this.path[0] = ['M', -newRadius, -newRadius];
      this.path[1] = ['M', newRadius, newRadius];
      this.path[3] = ['L', newPoint1[0], newPoint1[1]];
      this.path[4][1] = newRadius;
      this.path[4][2] = newRadius;
      this.path[4][6] = newPoint2[0];
      this.path[4][7] = newPoint2[1];
      this.width = newRadius * 2;
      this.height = newRadius * 2;
      this.scaleX = 1;
      this.scaleY = 1;
      break;
    case 'customFreehand':
      if (!isSingleSelect) {
        this.sx *= sx;
        this.sy *= sy;
        this.scaleX *= sx;
        this.scaleY *= sy;
      }
      break;
    default:
      break;
  }
};

// helper function to return the boundaries of a polygon/polyline
// something similar may be built in but it seemed easier to write my own than dig through the fabric.js code.  This may make me a bad person.
fabric.Object.prototype.getBoundingBox = function() {
  var minX = null;
  var minY = null;
  var maxX = null;
  var maxY = null;
  switch (this.type) {
    case 'egPolygon':
    case 'egPolyline': {
      const points = this.get('points');
      minX = fabric.util.array.min(points, 'x');
      minY = fabric.util.array.min(points, 'y');
      maxX = fabric.util.array.max(points, 'x');
      maxY = fabric.util.array.max(points, 'y');
      break;
    }
    case 'egPath':
      var path = this.get('path');

      for (let i = 0; i < path.length; i++) {
        var p = path[i];
        for (var m = 1; m < p.length; m = m + 2) {
          var x = p[m + 0];
          var y = p[m + 1];
          if (minX === null) {
            minX = x;
          } else if (x < minX) {
            minX = x;
          }
          if (minY === null) {
            minY = y;
          } else if (y < minY) {
            minY = y;
          }
          if (maxX === null) {
            maxX = x;
          } else if (x > maxX) {
            maxX = x;
          }
          if (maxY === null) {
            maxY = y;
          } else if (y > maxY) {
            maxY = y;
          }
        }
      }
      break;
    default:
      minX = this.left;
      minY = this.top;
      maxX = this.left + this.width;
      maxY = this.top + this.height;
  }
  return {
    topLeft: new fabric.Point(minX, minY),
    bottomRight: new fabric.Point(maxX, maxY),
    width: maxX - minX,
    height: maxY - minY,
  };
};

export { fabric };



// WEBPACK FOOTER //
// ./src/canvas/common/fabric/fabric.eg.js